import { format } from 'd3-format';
import { sankey, sankeyCenter, SankeyLayout } from 'd3-sankey';
import { scaleOrdinal } from 'd3-scale';
import { SankeyData, SankeyDataLink, SankeyDataNode } from 'types/sankey';

import { PathLink } from './sankey-link';
import { RectNode } from './sankey-rect';

// Create a color scale with your custom colors
const d3Color = scaleOrdinal<string>();

// Before using the color functions, set the domain based on your data
export const initializeColorScale = (data: SankeyData, colors: string[]) => {
  // Extract all unique node names to use as domain
  const nodeNames = Array.from(new Set(data.nodes.map((node) => node.key)));

  // Set the domain for the color scale
  d3Color.domain(nodeNames).range(colors);
};
export const colorRectFunc = (dataPoint: RectNode) => d3Color(dataPoint.key);

export const colorLinkFunc = (dataPoint: PathLink) => {
  const name =
    typeof dataPoint.target === 'object'
      ? (dataPoint.target as RectNode).name
      : dataPoint.target;

  return d3Color(name as string);
};

const d3format = format(',.0f');

export const formatRectTitleFunc = (dataPoint: RectNode) => {
  if (!dataPoint.value) return dataPoint.name;

  return `${dataPoint.name}\n${d3format(dataPoint.value)}`;
};

export const formatLinkTitleFunc = ({
  source,
  target,
  value,
}: PathLink): string => {
  const sourceName =
    typeof source === 'object' ? (source as RectNode).name : source;
  const targetName =
    typeof target === 'object' ? (target as RectNode).name : target;

  return `${sourceName} → ${targetName}\n${d3format(value)}`;
};

interface MakeSankeyInput {
  width: number;
  height: number;
  nodePadding: number;
  nodeWidth: number;
}

export const makeSankeyFunc = ({
  width,
  height,
  nodePadding,
  nodeWidth,
}: MakeSankeyInput): SankeyLayout<
  SankeyData,
  SankeyDataNode,
  SankeyDataLink
> => {
  const sankeyGen = sankey<SankeyDataNode, SankeyDataLink>()
    .nodeId((d) => d.key)
    .nodeWidth(nodeWidth)
    .nodePadding(nodePadding)
    .nodeAlign(sankeyCenter)
    .extent([
      [1, 5],
      [width - 1, height - 5],
    ])
    .linkSort((a, b) => b.value - a.value);

  return sankeyGen;
};
